<template>
    <div class="traffic-legend" :class="{ 'traffic-legend--single-column' : singleColumn }">
        <div class="traffic-legend__item" v-for="item in legend" :key="item.type">
            <div class="traffic-legend__item__line" :class="'traffic-legend__item__line--' + item.type" :style="item.image ? 'background-image: url('+ item.image +');' : ''"></div>
            <div class="black copy">{{ item.label }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        singleColumn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            legend: [
                {
                    type: 'normal',
                    label: 'Freie Fahrt',
                },
                {
                    type: 'medium',
                    label: 'Zähflüssiger Verkehr',
                },
                {
                    type: 'slow',
                    label: 'Stockender Verkehr',
                },
                {
                    type: 'jam',
                    label: 'Stau',
                },
                {
                    type: 'block',
                    label: 'Sperre',
                    image: `${process.env.BASE_URL}/images/ui/blocked-route-line.svg`
                },
            ],
        }
    }
}
</script>

<style lang="scss">
.traffic-legend {
    @include mq(tablet) {
        column-count: 2;
        column-gap: 6px;
    }
    &--single-column {
        @include mq(tablet) {
            column-count: 1;
        }
    }
    &__item {
        display: flex;
        align-items: center;
        padding: 6px 0;
        break-inside: avoid;
        &__line {
            width: 50px;
            height: 6px;
            margin-right: 16px;
            &--normal {
                background-color: #64c864;
            }
            &--medium {
                background-color: #fabe14;
            }
            &--slow {
                background-color: #e60f0f;
            }
            &--jam {
                background-color: #8d231e;
            }
            &--block {
            }
        }

    }
}
</style>